import { React } from 'react';
import styled from 'styled-components';

import TotalStatisticsView from '../Model/Individual/StatisticsModel/TotalStatisticsView.js';

function StatisticsPage() {

  return (
    <Container>
      <TotalStatisticsView/>
    </Container>
  )
}

export default StatisticsPage;

const Container = styled.div`
  display: flex;
  flex-direction: column;

  // width: 100%;
`;